import React from "react";
import Typography from "../../Typography/Typography";

const SelectedNodesList = ({ selectedNodes, onRemoveNode }) => {
    return (
        <div className="mt-4 pt-3 border-top">
            <div className="d-flex align-items-center mb-3">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                <Typography variant="h5" className="mb-0 form-label">
                    Selected Nodes
                </Typography>
                <span className="ms-2 badge bg-primary rounded-pill">
                    {selectedNodes.length}
                </span>
            </div>
            <div className="bg-light p-3 rounded-3 border">
                <div className="d-flex flex-wrap gap-2">
                    {selectedNodes.length > 0 ? (
                        selectedNodes.map((node) => (
                            <div
                                key={node.id}
                                className="badge bg-white text-dark border rounded-pill py-2 px-3 d-flex align-items-center shadow-sm"
                            >
                                <span>
                                    {node.name}{" "}
                                    <span className="text-secondary">
                                        ({node.project})
                                    </span>
                                </span>
                                <button
                                    type="button"
                                    className="btn-close ms-2"
                                    aria-label="Remove"
                                    onClick={() =>
                                        onRemoveNode(
                                            node.projectId,
                                            node.nodeId,
                                        )
                                    }
                                    style={{ fontSize: "0.6rem" }}
                                ></button>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-3 w-100">
                            <i className="bi bi-info-circle text-muted me-2"></i>
                            <span className="text-muted">
                                No nodes selected yet. Select nodes from the
                                panels above.
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SelectedNodesList;
